import React, { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import { GOLD_RATE_SOURCE } from '../../utils/finance/financeCostConstants';
import {
  loadFinanceCostRules,
  loadFinanceCostSettings,
  saveFinanceCostRule
} from '../../utils/finance/financeCostFirestore';
import { canManageFinanceCost } from '../../utils/finance/financePermissions';
import { usePriceContext } from '../../context/PriceContext';
import FinanceCostCatalog from './FinanceCostCatalog';

export default function FinanceCostSettings({ sube, activePersonel, branchAuthIsAdmin, preview }) {
  const canEdit = canManageFinanceCost(activePersonel, { branchAuthIsAdmin });
  const priceCtx = usePriceContext();
  const livePrices = preview?.prices || priceCtx?.prices || [];
  const [settings, setSettings] = useState({ defaultGoldRateSource: GOLD_RATE_SOURCE.LIVE_BUY, milyemByProductType: {} });
  const [rules, setRules] = useState([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (preview) {
      setSettings(preview.settings || { defaultGoldRateSource: GOLD_RATE_SOURCE.LIVE_BUY, milyemByProductType: {} });
      setRules(preview.rules || []);
      return;
    }
    if (!sube) return;
    Promise.all([loadFinanceCostSettings(sube), loadFinanceCostRules(sube)])
      .then(([s, r]) => {
        setSettings(s);
        setRules(r);
      })
      .catch(() => setMsg('Ayarlar okunamadı.'));
  }, [sube, preview]);

  const upsertLocal = (saved) => {
    setRules((prev) => {
      const rest = prev.filter((r) => r.id !== saved.id);
      return [saved, ...rest];
    });
  };

  const persistRule = async (payload, existingId) => {
    if (!canEdit) return;
    const matchId = existingId || rules.find((r) => r.scopeType === payload.scopeType && r.scopeId === payload.scopeId && r.active !== false)?.id;
    if (preview) {
      const saved = { id: matchId || `p-${Date.now()}`, ...payload, name: payload.name || payload.scopeId };
      upsertLocal(saved);
      setMsg('Kural kaydedildi. Yeni satışlar bu ayarı kullanır.');
      return saved;
    }
    const saved = await saveFinanceCostRule(sube, { ...payload, name: payload.name || payload.scopeId }, activePersonel, matchId);
    upsertLocal(saved);
    setMsg('Kural kaydedildi. Yeni satışlar bu ayarı kullanır.');
    return saved;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1, overflow: 'hidden' }} data-testid="finance-cost-settings">
      {msg ? <Alert severity="info" sx={{ py: 0, mb: 1, flexShrink: 0, '& .MuiAlert-message': { fontSize: 13 } }}>{msg}</Alert> : null}
      <FinanceCostCatalog
        prices={livePrices}
        rules={rules}
        settings={settings}
        canEdit={canEdit}
        onSaveRule={persistRule}
      />
    </Box>
  );
}
